require('./RAProjectionChartTooltip.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { first, get } = require('lodash');

// @commons
const RAOneLineSymbolAmount = require('../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { EURO_SYMBOL } = require('constants/index');

const {
    RA_PROJECTION_CHART_UP_KEY,
    RA_PROJECTION_CHART_MID_KEY,
    RA_PROJECTION_CHART_LOW_KEY,
} = require('../../raConstants/index');

class RAProjectionChartTooltip extends React.Component {
    getCurrentValues() {
        return get(first(this.props.payload), 'payload');
    }

    render() {
        const { active } = this.props;

        if (active) {
            const values = this.getCurrentValues();

            return (
                <ul className="ra-projection-chart-tooltip">
                    <li className="ra-projection-chart-tooltip--light-blue">
                        <span className="ra-projection-chart-tooltip__legend" />
                        <span className="ra-projection-chart-tooltip__amount">
                            <RAOneLineSymbolAmount
                                amountObject={{
                                    currency: EURO_SYMBOL,
                                    amount:
                                        values &&
                                        values[RA_PROJECTION_CHART_UP_KEY],
                                }}
                                trimDecimals={true}
                            />
                        </span>
                        <span className="ra-projection-chart-tooltip__description">
                            <FormattedText value="rentabilityGraph-maximumLabel" />
                        </span>
                    </li>
                    <li className="ra-projection-chart-tooltip--default">
                        <span className="ra-projection-chart-tooltip__legend" />
                        <span className="ra-projection-chart-tooltip__amount">
                            <RAOneLineSymbolAmount
                                amountObject={{
                                    currency: EURO_SYMBOL,
                                    amount:
                                        values &&
                                        values[RA_PROJECTION_CHART_MID_KEY],
                                }}
                                trimDecimals={true}
                            />
                        </span>
                        <span className="ra-projection-chart-tooltip__description">
                            <FormattedText value="rentabilityGraph-expectedLabel" />
                        </span>
                    </li>
                    <li className="ra-projection-chart-tooltip--grey">
                        <span className="ra-projection-chart-tooltip__legend" />
                        <span className="ra-projection-chart-tooltip__amount">
                            <RAOneLineSymbolAmount
                                amountObject={{
                                    currency: EURO_SYMBOL,
                                    amount:
                                        values &&
                                        values[RA_PROJECTION_CHART_LOW_KEY],
                                }}
                                trimDecimals={true}
                            />
                        </span>
                        <span className="ra-projection-chart-tooltip__description">
                            <FormattedText value="rentabilityGraph-minimumLabel" />
                        </span>
                    </li>
                </ul>
            );
        } else {
            return null;
        }
    }
}

RAProjectionChartTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array,
};

module.exports = RAProjectionChartTooltip;
